import appApi from 'service/app-api';
import nxLog from 'service/nx-log';
import nxLogLegacySend from 'service/nx-log-legacy';
import { rootStore } from 'store/root';

const { nxlApi, dataLayer, win } = window;

nxlApi.appsInstallerEvents.sub(async (key: string, data: any) => {
    switch (key) {
        case 'installedApps':
            rootStore.appStore.updateInstallInfos(data);
            break;
        case 'appInstallStatus':
            rootStore.appStore.updateInstallStatus(data.productID, data);
            break;
        case 'appInstallComplete':
            rootStore.appStore.updateInstallStatus(data.productID, {
                productID: data.productID,
                status: 'installed',
            });
            break;
        case 'appInstallCanceled':
            rootStore.appStore.updateInstallStatus(data.productID, {
                productID: data.productID,
                status: 'canceled',
            });
            break;
        case 'appUninstallSuccess':
            // const one = rootStore.appStore.library.find(x => x.productId === data.productID);
            // if (one) one.installInfo = cast({});
            rootStore.appStore.fetchInstallInfos();
            break;
        default:
    }
    if (win.name === 'main') {
        switch (key) {
            case 'appInstallStarted':
                if (data.isAutoUpdate) {
                    dataLayer.push({ event: 'updateAutoStart', gameName: data.productName });
                }
                return;
            case 'appInstallComplete':
                if (data.isInstall) {
                    const installedProductNames = rootStore.appStore.installedApps
                        .map((x) => x.displayName)
                        .sort()
                        .join('|');
                    dataLayer.push({ event: 'gameInstall', gameName: data.productName, gamesInstalled: installedProductNames });

                    nxLogLegacySend({
                        sequenceno: 3,
                        prevfunnelstagename: 'install_start',
                        funnelstagename: 'install_success',
                        funnelinfo: 'game_installation',
                        productId: data.productID,
                    });
                } else {
                    dataLayer.push({ event: 'updateComplete', gameName: data.productName });
                }

                nxLog.send({
                    comment: data.isInstall ? 'game install end' : 'game update end',
                    stage: data.isInstall ? 901 : 903,
                    productId: data.productID,
                });
                break;

            case 'appInstallCanceled':
                nxLog.send({
                    comment: data.isInstall ? 'game install end' : 'game update end',
                    errorcode: 2,
                    stage: data.isInstall ? 901 : 903,
                    productId: data.productID,
                });
                break;

            case 'appInstallFailed':
                nxLog.send(
                    {
                        comment: data.isInstall ? 'game install end' : 'game update end',
                        errorcode: 1,
                        stage: data.isInstall ? 901 : 903,
                        productId: data.productID,
                    },
                    { arena_error_code: data.errorCode, arena_error_message: data.errorMessage }
                );
                if (data.errorCode === 20520) {
                    // os compatibility warning
                    rootStore.dialogs
                        .error({
                            title: 'warning',
                            message: data.errorCode,
                            errorData: data.errorData,
                            confirmText: 'Yes',
                            cancelText: 'No',
                        })
                        .then((confirm) => {
                            if (confirm)
                                appApi.installAppWidthId(data.productID, {
                                    skipCompatibility: true,
                                });
                        });
                    return;
                }
                // e.g. FileNotFoundError: [WinError 3] The system cannot find the path specified: 'D:\\' (cannot find hard drive)
                if (data.errorMessage && data.errorMessage.startsWith('FileNotFoundError: [WinError 3]')) {
                    rootStore.dialogs.error({ title: 'installation-failed', message: 'NotFoundDrive' });
                    rootStore.appStore.library.find((x) => x.productId === data.productID)?.uninstall(true);
                    return;
                }
                rootStore.dialogs.error({ title: 'installation-failed', message: data.errorCode, errorData: data.errorData || data });
                break;

            case 'appUninstallSuccess':
                nxLog.send({
                    comment: 'game uninstall end',
                    stage: 911,
                    productId: data.productID,
                });
                break;
            case 'appUninstallFailed':
                nxLog.send({
                    comment: 'game uninstall end',
                    stage: 911,
                    productId: data.productID,
                    errorcode: 1,
                });
                const game = rootStore.appStore.pc.find((one) => one.productId === data.productID);
                rootStore.dialogs.error({
                    title: 'failed-to-uninstall-productname',
                    message: data.errorCode,
                    errorData: { productName: game?.name },
                });
                break;
        }
    }
});
